import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { EffectCoverflow, Pagination, Navigation, Autoplay } from "swiper/core";
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

SwiperCore.use([EffectCoverflow, Pagination, Navigation, Autoplay]);

const images = ["images/1.jpg", "images/2.jpg", "images/3.jpg", "images/13.jpg", "images/5.jpg", "images/6.jpg", "images/7.jpg",
    "images/8.jpg", "images/9.jpg", "images/10.jpg", "images/11.jpg", "images/12.jpg", "images/14.jpg",
]

const SwiperC = () => {
    return(
        <Swiper
            navigation={true}
            effect={"coverflow"}
            centeredSlides={true}
            slidesPerView={window.innerWidth < 768 ? 1 : "auto"}
            loop={true}
            autoplay={{ delay: 3000 }}
            coverflowEffect={{
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true
            }}
            pagination={{
                clickable: true
            }}
            className="mySwiper w-[90%] z-0 mb-10"
        >
            {
                images.map((item)=>
                    <SwiperSlide>
                        <img src={item} alt="Techkshetra Gallery" className='rounded-sm'/>
                    </SwiperSlide>
                )
            }
        </Swiper>
    )
}

export default SwiperC;
